import CustomerUserList from "./CustomerUserList";

export default {
  list: CustomerUserList,
};
